import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Stethoscope, User } from "lucide-react";

const ROLES = [
  { id: "doctor", label: "doctor", Icon: Stethoscope },
  { id: "patient", label: "patient", Icon: User },
];

export function RoleSelector({ role, setRole }) {
  return (
    <div className="mt-6 grid grid-cols-2 gap-2 p-1 bg-zinc-100 rounded-md">
      {ROLES.map(({ id, label, Icon }) => (
        <button
          key={id}
          type="button"
          data-testid={`role-${id}-btn`}
          onClick={() => setRole(id)}
          className={[
            "flex items-center justify-center gap-2 py-2 rounded-[6px] text-sm font-medium transition-colors capitalize",
            role === id ? "bg-white text-zinc-900 shadow-sm" : "text-zinc-500 hover:text-zinc-800",
          ].join(" ")}
        >
          <Icon className="h-4 w-4" />
          {label}
        </button>
      ))}
    </div>
  );
}

export function AuthFields({ mode, form, upd, error }) {
  return (
    <>
      {mode === "register" && (
        <div className="space-y-1.5">
          <Label htmlFor="name">Full name</Label>
          <Input id="name" data-testid="name-input" required value={form.name} onChange={upd("name")} placeholder="Dr. Jane Doe" />
        </div>
      )}
      <div className="space-y-1.5">
        <Label htmlFor="email">Email</Label>
        <Input id="email" data-testid="email-input" type="email" required value={form.email} onChange={upd("email")} placeholder="you@clinic.med" />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="password">Password</Label>
        <Input id="password" data-testid="password-input" type="password" required value={form.password} onChange={upd("password")} placeholder="••••••••" />
      </div>
      {error && (
        <p data-testid="auth-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">
          {error}
        </p>
      )}
    </>
  );
}
